import { useMemo } from "react";
import schema from "../../../gen/schema/witbooking.backoffice.insurance.v1/Insurance.json";

schema.properties.typology.properties.percentage.properties.sections.items.$ref =
  "#/definitions/witbooking.backoffice.insurance.v1.TypologySection";
schema.properties.typology.properties.amount.properties.sections.items.$ref =
  "#/definitions/witbooking.backoffice.insurance.v1.TypologySection";

export function useSchema() {
  return useMemo(
    () => ({
      ...schema,
      properties: {
        ...schema.properties,
      },
    }),
    []
  );
}
